export default __webpack_public_path__ + "static/media/undeadminionnecroticbomb.08fa5ed0.png";